import { render } from "./ViolationFlags.vue?vue&type=template&id=6b2e0df1&scoped=true"
import script from "./ViolationFlags.vue?vue&type=script&lang=js"
export * from "./ViolationFlags.vue?vue&type=script&lang=js"

import "./ViolationFlags.vue?vue&type=style&index=0&id=6b2e0df1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2e0df1"]])

export default __exports__